import React from "react";
import { css } from "@emotion/css";

const InlineChromiumBugfix = () => (
    <span contentEditable={false} className={css`font-size: 0;`}>
        {String.fromCodePoint(160) /* Non-breaking space */}
    </span>
)

export default InlineChromiumBugfix;